import { createContext } from 'react';
import initialBrandState from './initialBrandState';

const BrandContext = createContext(initialBrandState);

export default BrandContext;
